import React from 'react';

const RMC = () => {
    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>RMC</h1>
            </div>
        </div>
    );
};

export default RMC;